export default (data, myRatings) => {
    if (!myRatings) {
        return data;
    }

    return data.map(item => ({
        ...item,
        myRating: myRatings[item.raceInstanceUid],
    }));
};



// WEBPACK FOOTER //
// ./src/js/horse/form/formTable/mergeWithMR.js